import styled from "styled-components";
import { CardComp, ButtonComp } from "..";
import { formatMoney } from "../../utils/currencyFormat";
import { convertToTitleCase } from "../../utils/helpers";
import InvestorStatusBadge from "./InvestorStatusBadge";
import { investorButtonProps } from "./investorButtonStyles";

const RailCard = styled(CardComp)`
  && {
    position: sticky;
    top: 5.75rem;
    border: none;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    overflow: hidden;
  }
`;

const Price = styled.p`
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 0.15rem;
`;

const MobileBar = styled.div`
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
  padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom, 0px));
  background: #fff;
  border-top: 1px solid #e5e5e5;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);

  @media (max-width: 991px) {
    display: block;
  }
`;

const MobileSpacer = styled.div`
  height: 5.5rem;

  @media (min-width: 992px) {
    display: none;
  }
`;

export default function MarketplaceOrderSummaryRail({ product, onOrder, loading }) {
  if (!product) return null;

  const stockLabel = convertToTitleCase(product.stock?.replace(/_/g, " ") || "in stock");

  return (
    <>
      <RailCard cardClassName="d-none d-lg-block">
        <p className="small text-muted mb-2">Order summary</p>
        <h6 className="fw-bold mb-2" style={{ color: "#383838" }}>
          {product.name}
        </h6>
        <Price>{formatMoney(product.priceNgn)}</Price>
        <p className="small text-muted mb-3">{product.unit}</p>
        <div className="mb-3">
          <InvestorStatusBadge status={product.stock || "in_stock"} label={stockLabel} />
        </div>
        <ButtonComp
          btnText="Place order"
          onClick={onOrder}
          loading={loading}
          btnClassName="w-100"
          {...investorButtonProps.primary}
          ButtonInlineStyle={{ ...investorButtonProps.primary.ButtonInlineStyle, width: "100%" }}
        />
      </RailCard>

      <MobileBar>
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="min-w-0">
            <p className="small text-muted mb-0">{product.unit}</p>
            <p className="fw-bold mb-0 text-truncate" style={{ color: "var(--color-primary)" }}>
              {formatMoney(product.priceNgn)}
            </p>
          </div>
          <ButtonComp
            btnText="Place order"
            onClick={onOrder}
            loading={loading}
            btnClassName="flex-shrink-0"
            {...investorButtonProps.primary}
            ButtonInlineStyle={{ ...investorButtonProps.primary.ButtonInlineStyle, minWidth: 140 }}
          />
        </div>
      </MobileBar>
      <MobileSpacer aria-hidden />
    </>
  );
}
